var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuler(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 26.4956,
    fill: "url(#paint0_linear_1646_21061)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1646_21061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8492 19.2219L34.7782 12.1509C34.5906 11.9635 34.3363 11.8582 34.0712 11.8582C33.806 11.8582 33.5517 11.9635 33.3642 12.1509L30.5362 14.9789L32.6572 17.0999L31.2432 18.5139L29.1222 16.3929L27.0002 18.5149L29.8282 21.3429L28.4142 22.7569L25.5862 19.9289L23.4652 22.0499L25.5862 24.1709L24.1722 25.5849L22.0512 23.4639L19.9302 25.5849L22.7582 28.4129L21.3442 29.8269L18.5152 26.9999L16.3942 29.1209L18.5152 31.2419L17.1012 32.6559L14.9802 30.5349L12.1522 33.3629C11.9647 33.5505 11.8594 33.8048 11.8594 34.0699C11.8594 34.3351 11.9647 34.5894 12.1522 34.7769L19.2232 41.8479C19.4107 42.0354 19.665 42.1407 19.9302 42.1407C20.1953 42.1407 20.4496 42.0354 20.6372 41.8479L41.8492 20.6359C41.9421 20.5432 42.0158 20.4329 42.0662 20.3116C42.1165 20.1903 42.1424 20.0603 42.1424 19.9289C42.1424 19.7976 42.1165 19.6676 42.0662 19.5462C42.0158 19.4249 41.9421 19.3147 41.8492 19.2219ZM35.8392 21.6969C35.6935 21.5592 35.5769 21.3937 35.4963 21.2101C35.4156 21.0265 35.3726 20.8286 35.3698 20.6282C35.367 20.4277 35.4044 20.2287 35.4798 20.0429C35.5551 19.8571 35.667 19.6883 35.8088 19.5465C35.9505 19.4047 36.1192 19.2928 36.305 19.2173C36.4907 19.1418 36.6897 19.1044 36.8902 19.1071C37.0906 19.1098 37.2885 19.1527 37.4721 19.2333C37.6558 19.3138 37.8214 19.4303 37.9592 19.5759C38.2276 19.8596 38.3749 20.2369 38.3695 20.6275C38.3642 21.018 38.2067 21.3911 37.9306 21.6674C37.6544 21.9436 37.2814 22.1013 36.8909 22.1068C36.5003 22.1123 36.123 21.9653 35.8392 21.6969Z",
    fill: "url(#paint1_linear_1646_21061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9612 33.725C39.9148 33.5616 39.8274 33.4129 39.7072 33.2929L35.8642 29.45L29.4502 35.864L33.2932 39.707C33.4132 39.827 33.5622 39.915 33.7252 39.961L40.7252 41.961C40.8967 42.0106 41.0784 42.0132 41.2513 41.9687C41.4242 41.9242 41.5819 41.8342 41.7082 41.7079C41.8344 41.5817 41.9245 41.4239 41.969 41.251C42.0135 41.0781 42.0108 40.8965 41.9612 40.725L39.9612 33.725Z",
    fill: "url(#paint2_linear_1646_21061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1362 24.55L24.5502 18.136L18.7072 12.293C18.6144 12.2 18.5042 12.1263 18.3829 12.076C18.2616 12.0257 18.1315 11.9998 18.0002 11.9998C17.8689 11.9998 17.7388 12.0257 17.6175 12.076C17.4962 12.1263 17.386 12.2 17.2932 12.293L12.2932 17.293C12.2003 17.3857 12.1265 17.4959 12.0762 17.6173C12.0259 17.7386 12 17.8686 12 18C12 18.1313 12.0259 18.2613 12.0762 18.3827C12.1265 18.504 12.2003 18.6142 12.2932 18.707L18.1362 24.55Z",
    fill: "url(#paint3_linear_1646_21061)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1646_21061",
    x1: 10.5,
    y1: 2,
    x2: -38,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BC590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC0A5",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1646_21061",
    x1: 27.0009,
    y1: 11.8582,
    x2: 27.0009,
    y2: 42.1407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1646_21061",
    x1: 35.7253,
    y1: 29.45,
    x2: 35.7253,
    y2: 42.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1646_21061",
    x1: 18.2751,
    y1: 11.9998,
    x2: 18.2751,
    y2: 24.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1646_21061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuler);
export default __webpack_public_path__ + "static/media/ruler.c57ac53b4781349a6a73b64436a104a3.svg";
export { ForwardRef as ReactComponent };